import { assign } from '../../../../shared/Assign';
import { Translate } from '../../../../shared/LanguageService';

export function TransformCompareStoreys(
    compareStoreys: ICompareImagesStorey[],
    showEverything: boolean
): ICompareImagesStorey[] {
    let storeys: ICompareImagesStorey[] = assign([], compareStoreys);

    storeys.forEach((storey: ICompareImagesStorey) => {
        if (!showEverything) {
            storey.files = storey.files.filter((f: ICompareFile) => f.hiddenByDefault === false);
        }

        storey.files.forEach((file: ICompareFile) => {
            if (file.id === -1) {
                file.filename = `${Translate('view-order/admin-planorder/compare/delivery')} - ${
                    file.filename
                }`;
            } else {
                switch (file.fileType) {
                    case 0:
                        file.filename = `${Translate(
                            'view-order/admin-planorder/compare/annotation'
                        )} - ${file.filename} (${file.producer})`;
                        break;

                    case 1:
                        file.filename = `${Translate(
                            'view-order/admin-planorder/compare/blueprint'
                        )} - ${file.filename} (${file.producer})`;
                        break;

                    case 2:
                    case 4:
                        file.filename = `${Translate('view-order/admin-planorder/compare/2D')} - ${
                            file.filename
                        } (${file.producer})`;
                        break;

                    case 3:
                    case 5:
                        file.filename = `${Translate('view-order/admin-planorder/compare/3D')} - ${
                            file.filename
                        } (${file.producer})`;
                        break;
                }
            }
        });
    });
    
    return storeys;
}

export interface ICompareFile {
    id?: number;
    fileType: number;
    filename: string;
    producer: string;
    fileReference: string;
    hiddenByDefault: boolean;
    defaultBlueprint: boolean;
    defaultCompareImage: boolean;
}

export interface ICompareImagesStorey {
    id: number;
    name: string;
    storeyId: number;
    files: ICompareFile[];
}
